export const PROGRAMS = [
  {
    slug: "drumtalk",
    index: "1",
    name: "DrumTalk",
    label: "BIG TALKS FOR BIG ROOMS",
    short: "Restorative keynotes that gently weave brain science, story, and live percussion into an unforgettable, grounding experience.",
    stat: { value: "300+", label: "STAGES & SUMMITS" },
    hero: "Keynotes designed as gentle regulation experiences — the room breathes, drums, and settles together.",
    image: "https://caseymuze.com/wp-content/uploads/2025/07/cropped-IMG_7463-2Tyler-Loop-Season-8.jpg",
    whatHappens: [
      "An opening rhythm gently settles the collective nervous system and creates a sense of safety.",
      "Casey weaves accessible brain science with lived story, showing how rhythm settles and restores.",
      "Guided call-and-response drumming turns quiet listeners into a warm, connected community.",
      "A closing integration anchors the felt shift into language leaders can carry back to their communities.",
    ],
    greatFor: ["Conferences & Summits", "Corporate Wellness", "Mental-Health Organizations", "Educator In-Services"],
  },
  {
    slug: "percussion-pathways",
    index: "2",
    name: "Percussion Pathways",
    label: "FOR ELDERS & MEMORY CARE",
    short: "Gentle hand drumming that offers memory-care residents moments of clarity, joy, and reconnection.",
    stat: { value: "120+", label: "CARE SESSIONS" },
    hero: "For elders in memory care held in tender moments — rhythm reaches gently where words no longer can.",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_trauma-healing-tech/artifacts/fbwjmc0h_P%20Pathways%20.webp",
    logo: "/pathways-logo.png",
    whatHappens: [
      "Familiar tempos and songs open doors to preserved musical memory.",
      "Seated, low-strain patterns invite participation at any ability level.",
      "Eye contact and shared pulse rebuild social connection in the room.",
      "Staff learn simple rhythms to sustain regulation between visits.",
    ],
    greatFor: ["Memory Care Units", "Assisted Living", "Alzheimer's Programs", "Adult Day Centers"],
  },
  {
    slug: "percussion-pals",
    index: "3",
    name: "Percussion Pals",
    label: "FOR OUR LITTLEST LEARNERS",
    short: "Rhythm-based sessions that build focus, adaptability, and emotional vocabulary in early childhood.",
    stat: { value: "40+", label: "CLASSROOMS SERVED" },
    hero: "For our littlest learners still finding words — the beat becomes their first safe language.",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_trauma-healing-tech/artifacts/37lm0vl3_casey-with-kids%20pp.webp",
    logo: "/percussion-pals-logo.png",
    whatHappens: [
      "Sensory-graded warmups meet children exactly where their bodies are.",
      "Simple cross-hand patterns build coordination and self-regulation.",
      "Naming games pair each rhythm with a feeling, expanding emotional vocabulary.",
      "Co-regulation with caregivers extends the calm beyond the session.",
    ],
    greatFor: ["Daycares & Pre-K", "Early Intervention", "Neurodivergent Youth", "Family Programs"],
  },
  {
    slug: "trap-learning",
    index: "4",
    name: "TRAP Learning",
    label: "FOR SENSORY & DIFFERENT LEARNERS",
    short: "In partnership with The Rhythmic Arts Project (TRAP), rhythm meets each learner where they are — a gentle, sensory-friendly way to build focus, regulation, and connection for children and adults of all abilities.",
    stat: { value: "60+", label: "LEARNING GROUPS" },
    hero: "For sensory and different learners of every age — children and adults alike — hand drumming offers a joyful, low-pressure path to regulation, engagement, and learning.",
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_trauma-healing-tech/artifacts/jaauohqr_480230809_680594620958100_1730755669174107948_n.jpg",
    logo: "https://customer-assets-jt897jd0.emergentagent.net/job_trauma-healing-tech/artifacts/ytkjnbo7_trap-learning-logo.png",
    logoLight: true,
    partner: { name: "The Rhythmic Arts Project", url: "https://traplearning.org/", note: "Casey is a certified TRAP provider and partner of The Rhythmic Arts Project — the internationally recognized program empowering people of all abilities and ages through the transformative power of rhythm. Trained in their proven curriculum, Casey delivers TRAP with their guiding principle at heart: expect intelligence." },
    whatHappens: [
      "Sensory-friendly warmups honor each learner's pace and comfort.",
      "Rhythmic patterns give restless, overstimulated minds a steady anchor.",
      "Steady rhythm keeps the regulated brain available and open to learning.",
      "Learners leave with portable rhythms that re-anchor focus and calm on demand.",
    ],
    greatFor: ["Sensory Classrooms", "Neurodivergent Learners", "Special Education", "Different-Abilities Programs"],
  },
];

export const PERSONAS = [
  { role: "Speaker", body: "Restorative keynotes that break silence and build bridges — designed to gently settle a room, not just address it." },
  { role: "Author", body: "Amazon best-selling contributor — \u201cThe Anxious Rhythm of the Muted Black Boy,\u201d featured in Holistic Mental Health Vol. 2." },
  { role: "Drummer", body: "Hand drumming as a gentle, caring practice for emotional regulation, social connection, and cognitive engagement." },
];

export const PILLARS = [
  { title: "The Mission", body: "Bridging traditional therapeutic models and the creative spirit." },
  { title: "The Environment", body: "Bringing spatial concepts of musical healing into institutional realities." },
  { title: "The Impact", body: "The rhythm of the drum becomes the voice of the soul." },
];

export const TESTIMONIALS = [
  { name: "Katie Lafrenierre", role: "Parent", body: "My 14-year-old daughter has had trouble writing about feelings due to autism, and Casey really connected with her in his creative writing workshop. She was relaxed and responsive and learned so much. She's looking forward to the next one — he's amazing!" },
  { name: "Jamie Huff", role: "Alzheimer's Alliance of Smith County", body: "Casey offers a service to our Day Program clients that is vital. Drumming stimulates cognitively, socially, physically and emotionally. As one participant with dementia said, \u201cIt makes me feel ALIVE!\u201d" },
  { name: "Jacklyn Boyce", role: "Author", body: "He is an AMAZING speaker, leader, and motivator! Very knowledgeable, friendly and humorous. I will definitely be in contact again and 100% recommend!" },
  { name: "Stephanie Adams", role: "Mentoring Program", body: "We had Casey at a large event for mentors and mentees. All ages — from kindergarteners to retirees — enjoyed his interactive teaching and beautiful drums. I'd recommend AvenueSpeak to anyone." },
  { name: "Pengitime", role: "Workshop Participant", body: "Mr. Casey's writing workshop is more than learning how to write — it's a therapeutic way to express how you feel. A space that feels safe and open. A fun experience I recommend to everyone." },
  { name: "Region 7 ESC", role: "Education Partner", body: "Casey's sessions gave our educators practical, rhythm-based tools they could use the very next day. Staff left calmer, more connected, and genuinely inspired." },
  { name: "Denise M.", role: "Special Education Teacher", body: "For students who struggle to sit still or self-regulate, the drum gave them an anchor. I watched kids who rarely engage light up and stay present the whole session." },
  { name: "Marcus T.", role: "Conference Organizer", body: "Easily the most talked-about keynote of our summit. Casey didn't just speak to the room — he moved it. People were still drumming on tables at lunch." },
  { name: "Angela R.", role: "Memory Care Director", body: "Our residents lit up. Some who hadn't spoken in days were tapping, smiling, and making eye contact again. Casey brings something our care plans simply can't." },
  { name: "Brianna K.", role: "Parent & Caregiver", body: "My son is neurodivergent and rarely feels understood in group settings. With Casey, he felt safe. The rhythm gave him a voice when words were too much." },
];

